const hasCapitalizedFields = (attributes) => {
  return {
    getCapitalized(field) {
      return `${attributes[field].charAt(0).toUpperCase()}${attributes[field].slice(1)}`;
    },
  };
};

export default hasCapitalizedFields;
